import React from "react";
import { Routes, Route } from "react-router-dom";
import SignUp from "../pages/SignUp/SignUp";
import Navbar from "../components/Navbar/Navbar";
import Login from "../pages/Login/Login";
import Home from "../pages/Home/Home";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import ResetPassword from "../pages/ForgotPassword/ResetPassword";
import Courses from "../pages/Courses/Courses";
import CourseLevelPage from "../pages/CourseLevelPage/CourseLevelPage";
import CourseLevelDetails from "../pages/CourseLevelDetails/CoursesLevleDetails";
import Footer from "../components/Footer/Footer";
import ContactSection from "../pages/Contact/ContactSection";
import FAQ from "../pages/FAQ/FAQ";
import CourseRegisterForm from "../pages/CourseRegistrationForm/CourseRegistrationForm";
import Profile from "../pages/Progile/Profile";
import RegistrationForm from "../pages/RegistrationProfileForm/RegistrationForm";
import SearchResults from "../components/SearchResult/SearchResult";
import MyInterests from "../pages/MyInterests/MyInterests";
import TermsOfService from "../pages/Termandcondition/term";
import PrivacyPolicy from "../pages/PrivayPolicy/PrivacyPolicy";
import RefundPolicy from "../pages/RefundPolicy/RefundPolicy";
import ScrollToTop from "../pages/ScrollToTop/ScrollToTop";
import PaymentSuccess from "../pages/Payment/PaymentSuccess/PaymentSuccess";
import CartPage from "../pages/CartPage/CartPage";
import AdminPanel from "../pages/Adminpannel/Adminpanel";
import Services from "../pages/Services/Services";
import ExcelUpload from "../pages/ScheduleCourse/ExcelUpload/ExcelUpload";
import EcaScheduleList from "../pages/ScheduleCourse/Schedule";


const RouteApp = () => {
  return (
    <>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<ContactSection />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/courses/:courseId" element={<CourseLevelPage />} />
        <Route
          path="/courses/:courseId/level/:levelId"
          element={<CourseLevelDetails />}
        />
        <Route path="/services" element={<Services /> } />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<SignUp />} />
        <Route path="forgotpassword" element={<ForgotPassword />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/expofinterst" element={<CourseRegisterForm />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="registerprofile" element={<RegistrationForm />} />
        <Route path="/search" element={<SearchResults />} />
        <Route path="/myinterests" element={<MyInterests />} />
        <Route path="/TermsOfService" element={<TermsOfService />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/RefundPolicy" element={<RefundPolicy />} />
        <Route path="/paymentsuccess" element={<PaymentSuccess />} />
        <Route path="/addtocart" element={<CartPage />} />
        <Route path="/adminpanel" element={<AdminPanel />} />
        <Route path="exceleac" element={<ExcelUpload />} />
        <Route path="shadeule" element={<EcaScheduleList />} />
      </Routes>
      <Footer />
    </>
  );
};

export default RouteApp;
